import V2LogoIcon from "@/components/v2/icon/v2-logo-icon";
import { signOut, useSession } from "next-auth/react";
import Link from "next/link";
import React from "react";
import style from "./footer.module.css";

export interface IFooterComponentProps {
  hideLogin?: boolean;
}

const FooterComponent: React.FC<IFooterComponentProps> = ({ hideLogin }) => {
  const { status } = useSession();

  return (
    <div>
      <div className="w-full bg-[#1F1F1F] text-[#fff]">
        <div className="py-10 mx-auto text-center body-container">
          <div className="flex flex-col justify-between md:flex-row">
            <div className="mx-auto md:mx-0">
              <V2LogoIcon width={76} height={32} />
            </div>

            <div className="mt-10 md:mt-0">
              <div className="flex justify-center gap-2 md:gap-10">
                <nav className={style.nav}>
                  <div className="footer-menu-title">소개</div>
                  <a href="https://docs.codenbutter.com/">코드앤버터 안내서</a>
                  <a href="https://docs.codenbutter.com/update/latest.html">
                    새로운 기능소개
                  </a>
                  {hideLogin ? (
                    <></>
                  ) : status === "authenticated" ? (
                    <a onClick={() => signOut()}>로그아웃</a>
                  ) : (
                    <Link href="/login" legacyBehavior>
                      <a>로그인</a>
                    </Link>
                  )}
                </nav>
                <nav className={style.nav}>
                  <div className="footer-menu-title">이용 및 약관</div>
                  <a href="/agree/terms-of-service" rel="noreferrer">
                    이용약관
                  </a>
                  <a
                    className="font-bold"
                    href="/agree/privacy-policy"
                    rel="noreferrer"
                  >
                    개인정보처리방침
                  </a>
                  <a
                    href="https://codenbutter1.statuspage.io/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    서버상태
                  </a>
                </nav>
              </div>
            </div>
          </div>

          <ul className={style.footer_link}>
            <li>주식회사 퍼플아이오 |</li>
            <li>대표자 : 윤정훈 |</li>
            <li>사업자등록번호 : 559-87-01569 |</li>
            <li>통신판매번호 : 2021-서울강남-00687 |</li>
            <li>서울특별시 강남구 테헤란로 445, 3층 |</li>
            <li>대표번호 : 02-563-2351 |</li>
            <li>support@codenbutter.com</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default FooterComponent;
